<template>
  <div class="animated fadeIn" v-if="!editOrder">
    <b-row>
      <b-col lg="12">
        <c-table striped caption="<i class='fa fa-shopping-cart'></i> Lista de Pedidos" :items="items"
          :fields="fields">
        </c-table>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import _ from 'lodash'
import cTable from '../../components/Table.vue'
import * as Helper from './../../methods/helpers'

  export default {
    name: 'tables',
    components: {cTable},
    props: {
      participantId: false,
      editOrder: false,
      guestId: false
    },
    data () {
      return {
        items: [],
        fields: [
          {key: 'item', label: 'Item', sortable: true},
          {key: 'description', label: 'Descrição', sortable: true}
          // {key: 'code', label: 'Código', sortable: true},
          // {key: 'updated', label: 'Última atualização', sortable: true}
          // {key: 'status', label: 'Status', sortable: true},
          // {key: 'actions', label: 'Ações'}
        ],
        excelFields: {
          'Item': 'item',
          'Descrição': 'description'
          // 'Código': 'code',
          // 'Última atualização': 'updated'
          // 'Status': 'status'
        },
        excelData: [],
        loading: false
      }
    },
    watch: {
      participantId: function (val) {
        this.mount()
      },
      editOrder: function (val) {
        this.mount()
      }
    },
    methods: {
      mount () {
        if (this.participantId !== false && this.participantId !== undefined) {
          this.$http.get(`flights/${this.participantId}`)
            .then(response => {
              console.log(response.data);
              let search = 'extras'
              if (this.guestId) {
                search = 'guestsExtras'
              }

              response.data[search].forEach(data => {
                if (this.guestId) {
                  if (this.guestId !== data.guest_id) {
                    return
                  }
                }
                let order = {}
                if (data.status === 0) {
                  order.status = 'Pendente'
                } else {
                  order.status = 'Concluído'
                }

                order.description = data.extra.formatted_name !== null
                  ? data.extra.formatted_name
                  : data.observation

                if (data.extra.name === 'flight') {
                  order.item = 'Voo'
                  order.description = data.desc
                } else if (
                  data.extra.name !== 'return_transfer' &&
                  data.extra.name !== 'departure_transfer' &&
                  data.extra.name !== 'refuse_transfer' &&
                  data.extra.name !== 'observation') {
                  order.item = 'Extra'
                } else if (data.extra.name === 'observation') {
                  order.item = 'Observação'
                } else {
                  order.item = 'Adicional'
                }
                if (data.extra.name === 'hosting_days') {
                  order.item = 'Dias da hospedagem extra';
                  order.description = data.hosting_days;
                }
                order.updated = Helper.formatDate(data.updated_at, true)
                order.code = data.code
                order.actions = {show: true, id: data.id, edit: 'order'}
                this.items.push(order)
              })

              if (!this.guestId) {
                const flight = response.data.participantFlight
                if (flight) {
                  if (flight.different_flight) {
                    this.items.push({
                      item: 'Voo',
                      description: 'Algum dos acompanhantes necessita de um voo diferente'
                    })
                  }
                  if (flight.extend_date) {
                    this.items.push({
                      item: 'Voo',
                      description: 'Deseja realizar alteração de data de retorno e/ou adicionar trechos nesse voo mediante disponibilidade e custo adicional.'
                    })
                  }
                  if (flight.flight_id === 26) {
                    this.items.push({
                      item: 'Voo',
                      description: 'Opção 21 - Data Oficial - Chegada dia 18 e saída dia 22 de abril.'
                    })
                  }
                }
              }

              this.items = _.sortBy(this.items, 'item')
              this.excelData = this.items
            })
        }
      }
    },
    mounted () {
      this.mount()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/orders/List.vue